import { CameraMemo } from "~/_legacy/types/analysis";
import { CameraMemoResponse } from "~/_legacy/types/api";
import { convertCameraMemoResponseToCameraMemo } from "~/_legacy/utils/convert";
import axiosInstance from "./axios-instance";

const createApiUrl = (branchUid: string) => `branches/${branchUid}/comments/`;

export const fetchCameraMemos = async ({
  branchUid,
  branchVersionId,
}: {
  branchUid: string;
  branchVersionId?: number;
}) => {
  const url = createApiUrl(branchUid);
  const { data } = await axiosInstance.get<CameraMemoResponse[]>(url, {
    params: {
      version: branchVersionId,
    },
  });

  const converted: CameraMemo[] = data.map(convertCameraMemoResponseToCameraMemo);

  return converted;
};
